"use strict";

exports.__esModule = true;
exports.makeDynamicProps = void 0;
var _wixDataSchemaTypes = require("@wix/wix-data-schema-types");
var _dataset = require("../../entities/dataset");
var _propEntryMaker = require("./prop-entry-maker");
var _makeValuePresentation = require("./make-value-presentation");
const makeDynamicProps = ({
  connection,
  dataset,
  schema,
  referencedSchemas,
  currentRecord
}, dependencies) => {
  const componentProps = [];
  if (Object.keys(connection.dynamicProperties).length) {
    for (const [name, dynamicPropConnection] of Object.entries(connection.dynamicProperties)) {
      const result = dynamicPropsSetters[name]({
        dataset,
        schema,
        referencedSchemas,
        currentRecord,
        connection: dynamicPropConnection
      }, dependencies);
      if (result) {
        componentProps.push(result);
      }
    }
  }
  return componentProps;
};
exports.makeDynamicProps = makeDynamicProps;
const makeTextPropEntry = (0, _propEntryMaker.propEntryMaker)(({
  valueData: {
    value,
    type,
    fieldType: connectedFieldType
  },
  connection: {
    typeMapping,
    extraData,
    propName,
    format
  }
}, dependencies) => {
  const fieldType = type === 'htmlString' ? _wixDataSchemaTypes.FieldType.richText : connectedFieldType;
  return [typeMapping[fieldType] ?? propName, connectedFieldType === _wixDataSchemaTypes.FieldType.url ? makeLinkFromText(value, extraData) : (0, _makeValuePresentation.makeValuePresentation)({
    format,
    value,
    dataType: 'text',
    fieldType: connectedFieldType
  }, dependencies)];
});
const makeLinkFromText = (fieldValue, extraData) => {
  // TODO: this old hack makes href without doublequotes, but this required in old viewer Text comp
  // rethink this solution
  const value = fieldValue ? fieldValue : '';
  return `<a href=${value} target="${(extraData == null ? void 0 : extraData.target) ?? '_blank'}"${extraData != null && extraData.rel ? ` rel="${extraData.rel}"` : ''} style="text-decoration: underline">${value}</a>`;
};
const makeLinkPropEntry = (0, _propEntryMaker.propEntryMaker)(({
  valueData: {
    value
  },
  connection: {
    propName
  }
}, {
  mediaUtils
}) => {
  let link;
  if (value) {
    try {
      link = mediaUtils.convertToUrl(value);
    } catch {
      link = value;
    }
  } else {
    link = '';
  }
  return [propName, link];
});
const makeTotalCountPropEntry = ({
  dataset,
  connection: {
    propName
  }
}) => {
  if (dataset.pagination.type === 'cursor') {
    return undefined;
  }
  return [propName, String(_dataset.Dataset.getTotalCount(dataset))];
};
const dynamicPropsSetters = {
  text: makeTextPropEntry,
  link: makeLinkPropEntry,
  totalCount: makeTotalCountPropEntry
};
//# sourceMappingURL=make-dynamic-props.js.map